import * as React from 'react';
import {Component} from 'react';
import Helmet from 'react-helmet';
import Link from 'gatsby-link';
import {TopLinksContent} from "../shared/top-links";
import {SidebarContent} from "../shared/sidebar";

// require("tachyons");
import * as meLogo from "../images/me-242.jpg"; // Tell Webpack this JS file uses this image
import * as frontImage from "../images/home-banner.jpg"; // Tell Webpack this JS file uses this image
// icons
import * as FaHome from 'react-icons/lib/fa/home';
import * as FaInfo from 'react-icons/lib/fa/info';
import * as FaLinkedin from 'react-icons/lib/fa/linkedin';
import * as FaTwitter from 'react-icons/lib/fa/twitter';
import * as FaGithub from 'react-icons/lib/fa/github';
import * as FaFacebook from 'react-icons/lib/fa/facebook';
import * as FaBook from 'react-icons/lib/fa/book';


// Please note that you can use https://github.com/dotansimha/graphql-code-generator
// to generate all types from graphQL schema
interface IndexPageProps {
    data: {
        site: {
            siteMetadata: {
                title: string;
            };
        };
    };
}

class IndexPage extends Component<IndexPageProps, {}> {
    constructor(props: IndexPageProps, context: any) {
        super(props, context);
    }
    render() {
        let site = this.props.data.site.siteMetadata;
        const posts = this.props.data.allMarkdownRemark.edges;

        // sort the posts
        posts.sort((a, b) => {
            let dateA = new Date(a.node.frontmatter.date);
            let dateB = new Date(b.node.frontmatter.date);
            return dateB - dateA;
        });

        // remove the non-blog pages and draft posts
        let blogPosts: any[] = [];
        for (let i=0; i < posts.length; i++) {
            let item = posts[i];
            if (item.node.id.indexOf("/pages/blog/") < 0 || item.node.frontmatter.state == "draft") {
                //posts.splice(i, 1);
                continue;
            }
            blogPosts.push(item);
        };
        // set the year
        let currentYear;
        blogPosts.forEach((item) => {
            let dateA = new Date(item.node.frontmatter.date);
            if (currentYear !== dateA.getFullYear()) {
                currentYear = item.node.frontmatter.year = dateA.getFullYear();
            }
        });

        return (
            <div>
                <Helmet title={`Jaanek Oja`} />
                <header>
                    <div className="home-icon">
                        <a href="/" className="link"><FaHome/></a>
                    </div>
                    <div className="top-links">
                        {/*<a href="/resume" className="link"><FaBook/><span className="link-text">R&eacute;sum&eacute;</span></a>*/}
                        <a href="/info" className="link"><FaInfo/><span className="link-text">Info</span></a>
                    </div>
                    <div className="image-area" style={{backgroundImage: "url(" + frontImage + ")"}}>
                        <div className="me-logo">
                            <img className="img-cicle" src={meLogo} alt="Me & Myself"/>
                            <div className="text">
                                <h1 className="headline">Jaanek Oja</h1>
                                <h4 className="subline">Software Engineer, Web Developer, Freelancer</h4>
                                <ul className="social list">
                                    <li><a href="https://www.linkedin.com/in/jaanek" className="icon facebook"><FaLinkedin/><span className="icon-text">/in/jaanek/</span></a></li>
                                    <li><a href="https://twitter.com/jaanekoja" className="icon twitter"><FaTwitter/><span className="icon-text">@jaanekoja</span></a></li>
                                    <li><a href="https://github.com/jaanek" className="icon github"><FaGithub/><span className="icon-text">/jaanek</span></a></li>
                                    <li><a href="https://www.facebook.com/jaanek/" className="icon linkedin"><FaFacebook/><span className="icon-text">fb.com/jaanek</span></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </header>
                <main className="content">
                    <div className="left blog-list">
                        {blogPosts.filter(post => post.node.frontmatter.title.length > 0).map(({ node: post }) => {
                            return (
                                <div className="content" key={post.id}>
                                    {post.frontmatter.year ? <h3>{post.frontmatter.year}</h3> : null}
                                    <ul className="list">
                                        <li>
                                            <span className="date">{post.frontmatter.date}</span>
                                            <Link to={post.frontmatter.path} className="link">{post.frontmatter.title}</Link>
                                        </li>
                                    </ul>
                                </div>
                            )
                        })}
                    </div>
                    <SidebarContent/>
                </main>
            </div>
        );
    }
}
export default IndexPage;

export const pageQuery = graphql`
  query IndexPageQuery{
    site {
      siteMetadata {
        title
      }
    },
    allMarkdownRemark(sort: { order: DESC, fields: [frontmatter___date] }) {
      edges {
        node {
          excerpt(pruneLength: 250)
          id
          frontmatter {
            title
            date(formatString: "MMMM DD, YYYY")
            path
            state
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.tsx